import { ProvideAuth } from "./hooks/useAuth";
import { ProvideFeatures } from "./hooks/useFeatures";
import { ProvideNoteType } from "./hooks/useNoteType";
import { ProvideJob } from "./hooks/useJobs";
import { ProvidePostMessages } from "./hooks/usePostMessages";
import { ProvideChats } from "./hooks/useChats";
import { ProvideRecorder } from "./hooks/useRecorder";
import { ProvideEHR } from "./hooks/useEHR.js";
import { ProvideIndexDb } from "./hooks/useIndexDb.js";
import { ProvideTheme } from "./hooks/useTheme.js";
import Layout from "./Layout";
import "./libs/exif-heic.min.js";
import { ErrorBoundary } from "@sentry/react";
import ErrorRender from "./components/common/ErrorRender.js";

function App() {
  return (
    <ErrorBoundary fallback={<ErrorRender showReload={true}></ErrorRender>}>
      <ProvideTheme>
        <ProvideAuth>
          <ProvideFeatures>
            <ProvideNoteType>
              <ProvideJob>
                <ProvideChats>
                  <ProvidePostMessages>
                    <ProvideIndexDb>
                      <ProvideRecorder>
                        <ProvideEHR>
                          <Layout></Layout>
                        </ProvideEHR>
                      </ProvideRecorder>
                    </ProvideIndexDb>
                  </ProvidePostMessages>
                </ProvideChats>
              </ProvideJob>
            </ProvideNoteType>
          </ProvideFeatures>
        </ProvideAuth>
      </ProvideTheme>
    </ErrorBoundary>
  );
}

export default App;
